import React from 'react';
import './index.less';
import { Col, Drawer, Menu } from 'antd';
import { Link } from 'react-scroll';
import { Link as DomLink } from 'react-router-dom';
import logoImg from '../../assets/svgImg/logo.svg';
import menuImg from '../../assets/svgImg/menuDrawerImg.svg';

class SliderMenu extends React.PureComponent {
  state = {
    current: 'mail',
    visible: false,
  };
  showDrawer = () => {
    this.setState({
      visible: true,
    });
  };
  onClose = () => {
    this.setState({
      visible: false,
    });
  };

  render() {
    const menuList = mode => (
      <Menu mode={mode} className="menu">
        <Menu.Item key="technical">
          <Link to="goTechnicalResources" spy smooth duration={500} delay={500}>
            Technical Resources
          </Link>
        </Menu.Item>
        <Menu.Item key="us">
          <Link to="goContactUs" spy smooth duration={500} delay={500}>
            Contact us
          </Link>
        </Menu.Item>
        <Menu.Item key="privacy">
          <DomLink to="/privacy">
            Privacy
          </DomLink>
        </Menu.Item>
      </Menu>
    );

    return (
      <Col className="menuCon">
        <Col className="leftMenu">
          <Link to="goHome" spy smooth duration={500} delay={500}>
            <img src={logoImg} className="logo" key="home" />
          </Link>
          {menuList('horizontal')}
        </Col>
        <Col className="barsMenu" onClick={this.showDrawer}>
          <span className="barBtn">
            <img src={menuImg} />
          </span>
        </Col>
        <Drawer
          className="menuDrawer"
          placement="right"
          closable={false}
          onClose={this.onClose}
          visible={this.state.visible}
        >
          {menuList('vertical')}
        </Drawer>
      </Col>
    );
  }
}
export default SliderMenu;
